import {valueSchema, validationSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'select_the_facs_applicable_three_letter_currency_code'

export const dataPointDefinition = {
  retracedId: 'select_the_facs_applicable_three_letter_currency_code',
  name: "Please select the facility's applicable three letter currency code:",
  description:
    'The intent of this question is to understand which three letter currency code is in use in the country in which the facility is located. Please select the most appropriate currency symbol in use (i.e. BDT, VND, CNY, USD etc.) \r\r\n\r\r\nFor example, if your facility is based in Vietnam and workers are paid in Vietnamese Dong, the selection response would be VND. \r\r\n\r\r\nIf your three letter code is not listed, or the facility uses more than one code, please select "Other" and describe.',
  meta: {
    asset: 'COUNTRIES_CURRENCY_CODE',
    constantsValidation: true,
  },
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-1',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 7220,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = async (data, {validatorFn}) => {
  try {
    validate({value: data, schema: valueSchema})

    if (!validatorFn) {
      throw new Error(`missing constants function`)
    }

    if (typeof validatorFn !== 'function') {
      throw new Error(`expect constants function to be a function, got ${typeof validatorFn}`)
    }

    const validConstants = await validatorFn()
    validate({value: validConstants, schema: validationSchema})
    const constantsId = validConstants.map(constant => constant.id)
    let value = data.value

    if (dataPointDefinition.schema.properties.value.type !== 'array') {
      value = [{id: value}]
    }

    const isValueAcceptable = value.every(entry => constantsId.includes(entry.id))
    if (!isValueAcceptable) throw new Error(`the value was invalid`)

    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
